module.exports = __webpack_public_path__ + "img/avatar48-3.ae99a421.png";